import React from 'react';
import { Page } from '../types';

interface AdminSidebarProps {
  currentPage: Page;
  setPage: (page: Page) => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ currentPage, setPage }) => {
  const menuItems: { label: string; page: Page; icon: string }[] = [
    { label: 'Dashboard', page: 'admin-dashboard', icon: 'dashboard' },
    { label: 'Registrations', page: 'admin-registrations', icon: 'how_to_reg' },
    { label: 'Compliance Tools', page: 'admin-registrations', icon: 'verified_user' },
    { label: 'Settings', page: 'admin-settings', icon: 'settings' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('fintrack_is_admin');
    setPage('home');
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-slate-900 text-white z-50 flex flex-col p-6">
      <div className="flex items-center gap-3 mb-12 p-2">
        <img 
          src="https://res.cloudinary.com/dohuj4mx9/image/upload/v1769023542/fintrack_logo_unique_v1-removebg-preview_oc4bqx.png" 
          alt="Logo" 
          className="w-10 h-10 object-contain"
        />
        <div className="font-display font-bold text-xl tracking-tight">FinTrack <span className="text-accent-400">HQ</span></div>
      </div>

      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => (
          <button
            key={item.page}
            onClick={() => setPage(item.page)}
            className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl transition-all ${currentPage === item.page ? 'bg-primary text-white shadow-lg' : 'text-slate-400 hover:text-white hover:bg-white/5'}`}
          >
            <span className="material-symbols-rounded text-xl">{item.icon}</span>
            <span className="text-sm font-bold">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="mt-auto space-y-4">
        <div className="p-4 bg-white/5 rounded-2xl border border-white/10">
          <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">Signed in as</p>
          <p className="text-xs font-bold truncate">Officer Obinna</p>
        </div>
        <button 
          onClick={handleLogout}
          className="w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl text-red-400 hover:bg-red-500/10 transition-all font-bold text-sm"
        >
          <span className="material-symbols-rounded text-xl">logout</span>
          Sign Out
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;